import { MobileGamepadInput } from './MobileGamepadInput';
import { MobileGamepadUi } from './MobileGamepadUi';

type LocalProps = {
  testMode?: boolean;
};

export const MobileGamepad = (props: LocalProps) => {
  const { testMode } = props;
  return (
    <>
      <MobileGamepadInput />
      <MobileGamepadUi testMode={testMode} />
    </>
  );
};
